export class InvestigationConversionReasonEntity {
  public id!: string;
  public name!: string;
  public sortOrder!: number;
}
